const BulletinData = [
  {
    "id": 0,
    "title": "徵人",
    "author": "admin",
    "date": "2023-06-07",
    "content": "如果有同學對於網站前端設計、後端開發、marketing 或 product management 有興趣的話都歡迎私訊 <a href='https://www.facebook.com/nctuplus' target='_blank' rel='noopener noreferrer'>FB粉專</a>，我們正在徵求下一屆NCTU+組織的團員，可以參考<a href='https://fsh0524.github.io/NCTU-plus-example/index/' target='_blank' rel='noopener noreferrer'>NCTU+組織簡單介紹</a> ，如果你有任何覺得交大師生可能會喜歡且需要的功能的想法，或覺得我們有哪裡可以做得更好的地方，都歡迎加入我們，一起實現你的想法！"
  },
  {
    "id": 1,
    "title": "網站更新紀錄",
    "author": "admin",
    "date": "2023-07-20",
    "content": "📢 115/03/28 新增教授心得功能，並支援以 NYCU／NCTU Google 帳號登入 \n 📢 112/10/22 新增上傳圖片的功能，可以在心得中加入圖片！ \n 📢 112/09/03 新版NCTU+正式上線，新增留言功能"
  }
]

export default BulletinData;